import React, {useState} from 'react';
import {TooltipHost} from '@fluentui/react/lib/Tooltip';
import {DirectionalHint} from '@fluentui/react/lib/Callout';
import {DefaultButton, PrimaryButton} from '@fluentui/react/lib/Button';
import {Dialog, DialogFooter} from '@fluentui/react/lib/Dialog';
import {Spinner, SpinnerSize} from "@fluentui/react/lib/Spinner";

interface Props {
  title: string;
  dialogMessage: string | React.ReactNode;
  community: any;
  buttonProps: any;
  tooltipProps: any;
  onClickAction(event: React.MouseEvent<HTMLElement>): Promise<boolean>;
}

const LeaveCommunityComponent = (props: Props) => {
  const { community, tooltipProps, buttonProps, title, dialogMessage, onClickAction } = props;
  const [isLeaveDialogOpen, setIsLeaveDialogOpen] = useState<boolean>(false);
  const [isLeaveButtonDisabled, setIsLeaveButtonDisabled] = useState<boolean>(false);
  const [isLeaveLoading, setIsLeaveLoading] = useState<boolean>(false);
  const [showLeaveConfirmation, setShowLeaveConfirmation] = useState<boolean>(false);

  const showLeaveDialog = () => {
    setIsLeaveDialogOpen(true);
  };

  const closeLeaveDialog = () => {
    setIsLeaveDialogOpen(false);
    setIsLeaveButtonDisabled(false);
  };

  const handleLeaveAction = async (event: React.MouseEvent<HTMLElement>) => {
    setIsLeaveButtonDisabled(true);
    setIsLeaveLoading(true);
    const _ret = await onClickAction(event);
    if ( typeof _ret === 'boolean' ) {
      setShowLeaveConfirmation(_ret);
    }
    setIsLeaveLoading(false);

    setTimeout(() => {
      setIsLeaveDialogOpen(false);
    }, 2500);
  }

  return (
    <>
      <TooltipHost
        content={tooltipProps.content}
        directionalHint={DirectionalHint.leftTopEdge}
      >
        <DefaultButton
          iconProps={{
            iconName: 'Leave',
            styles: {
              root: {
                fontSize: 24,
                height: 24,
                width: 24,
                lineHeight: 24,
                backgroundColor: '#eaeaea',
                boxSizing: 'content-box',
                marginLeft: 0,
                padding: 8,
                borderRadius: 8
              }
            }
          }}
          text={title}
          ariaLabel={title}
          onClick={showLeaveDialog}
          disabled={buttonProps.disabled}
          styles={{
            root: {
              backgroundColor: 'transparent',
              height: 40,
              paddingLeft: 0
            },
            rootHovered: {
              backgroundColor: 'transparent'
            }
          }}
        />
      </TooltipHost>

      <Dialog
        key='dialog-leave'
        hidden={!isLeaveDialogOpen}
        onDismiss={closeLeaveDialog}
        dialogContentProps={{
          title: `Leave '${community.displayName}'`
        }}
        modalProps={{
          isBlocking: true,
          isDarkOverlay: true,
          className: 'govTeams-dialog'
        }}
      >
        <p>{showLeaveConfirmation === true ? 'Request submitted & being processed!':dialogMessage}</p>

        <DialogFooter>
          <DefaultButton
            onClick={closeLeaveDialog}
            text='Cancel'
          />
          <PrimaryButton
            onClick={handleLeaveAction}
            text={title}
            disabled={isLeaveButtonDisabled}
          />
          {isLeaveLoading && (
              <Spinner size={SpinnerSize.small} />
          )}
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default LeaveCommunityComponent;
